<div *ngIf="showSection" class="accordion" id="accordionSummaryPrice">
  <button
    *ngIf="!readOnly"
    class="sidebar__trigger"
    data-bs-toggle="collapse"
    data-bs-target="#collapseSummaryPrice"
    aria-expanded="true"
    aria-controls="collapseSummaryPrice"
  >
    <h5 class="h5 sidebar__section-title">
      {{ 'sharedModule.bkgSummaryPrice.price' | translate }}
    </h5>
  </button>
  <h5 *ngIf="readOnly" class="h5 sidebar__section-title">
    {{ 'sharedModule.bkgSummaryPrice.price' | translate }}
  </h5>
  <div
    id="collapseSummaryPrice"
    class="accordion-collapse collapse show"
    data-bs-parent="#accordionSummaryPrice"
  >
    <div class="accordion-body">
      <div class="sidebar__content">
        <div class="sidebar__content-item">
          <div class="sidebar__price-item">
            <span class="sidebar__price-item-name">
              <b>Parking</b>
            </span>
          </div>
          <div class="sidebar__price-item">
            <span
              id="bkgSummaryPriceProductName"
              class="sidebar__price-item-name"
            >
              {{ productName }}
            </span>
            <span
              id="bkgSummaryPricePvpProductRaw"
              *ngIf="pvpProductRaw"
              class="sidebar__price-item-price"
              >{{ offerData?.offer?.pvp_product_raw | number: '1.2-2'
              }}{{ 'common.euro' | translate }}</span
            >
            <span *ngIf="!pvpProductRaw" class="sidebar__price-item-price">{{
              'sharedModule.bkgSummaryPrice.free' | translate
            }}</span>
          </div>
          <div *ngIf="pvpCarServiceDiscount" class="sidebar__price-item">
            <span class="sidebar__price-item-name">
              {{
                'sharedModule.bkgSummaryPrice.carServiceDiscount' | translate
              }}
            </span>
            <img
              *ngIf="!readOnly"
              (click)="onClickDiscountCarService()"
              src="assets/images/icons/info.svg"
              [class]="
                testABMode
                  ? 'sidebar__price-item-image-B'
                  : 'sidebar__price-item-image'
              "
            />
            <span
              id="bkgSummaryPricePvpCarServiceDiscount"
              class="sidebar__price-item-price"
              >{{ -offerData?.offer?.pvp_carservice_discount | number: '1.2-2'
              }}{{ 'common.euro' | translate }}</span
            >
          </div>
          <div *ngIf="selectedPlace" class="sidebar__price-item">
            <div>
              <span
                id="bkgSummaryPriceSelectedPlace"
                [class.sidebar__price-item-text]="!readOnly"
                >{{ selectedPlace.name }}</span
              >
              <img
                *ngIf="!readOnly"
                (click)="onClickDetailExtra(selectedPlace)"
                src="assets/images/icons/info.svg"
                [class]="
                  testABMode
                    ? 'sidebar__price-item-image-B'
                    : 'sidebar__price-item-image'
                "
              />
              <img
                *ngIf="!readOnly"
                (click)="onClickRemoveExtra(selectedPlace)"
                src="assets/images/icons/close.svg"
                [class]="
                  testABMode
                    ? 'sidebar__price-item-image-B'
                    : 'sidebar__price-item-image'
                "
              />
            </div>
            <span
              id="bkgSummaryPricePvpProductOption"
              *ngIf="pvpProductOption"
              class="sidebar__price-item-price"
              >{{ offerData?.offer?.pvp_product_option | number: '1.2-2'
              }}{{ 'common.euro' | translate }}</span
            >
            <span *ngIf="!pvpProductOption" class="sidebar__price-item-price">{{
              'sharedModule.bkgSummaryPrice.free' | translate
            }}</span>
          </div>
          <div *ngIf="pvpDoubleSpace" class="sidebar__price-item">
            <div>
              <span
                id="bkgSummaryPriceDoubleSpace"

              >{{'sharedModule.bkgSummaryPrice.doubleSpace' | translate}}</span
              >

            </div>
            <span id="bkgSummaryDoubleSpace" class="sidebar__price-item-price"
            >{{ offerData?.offer?.pvp_double_space | number: '1.2-2'
              }}{{ 'common.euro' | translate }}</span
            >
          </div>
          <div *ngIf="pvpProductWash" class="sidebar__price-item">
            <div>
              <span
                id="bkgSummaryPriceSelectedWash"
                [class.sidebar__price-item-text]="!readOnly"
                >{{ selectedWash.name }}</span
              >
              <img
                *ngIf="!readOnly"
                (click)="onClickDetailExtra(selectedWash)"
                src="assets/images/icons/info.svg"
                [class]="
                  testABMode
                    ? 'sidebar__price-item-image-B'
                    : 'sidebar__price-item-image'
                "
              />
              <img
                *ngIf="!readOnly"
                (click)="onClickRemoveExtra(selectedWash)"
                src="assets/images/icons/close.svg"
                [class]="
                  testABMode
                    ? 'sidebar__price-item-image-B'
                    : 'sidebar__price-item-image'
                "
              />
            </div>
            <span id="bkgSummaryPricePvpWash" class="sidebar__price-item-price"
              >{{ offerData?.offer?.pvp_wash | number: '1.2-2'
              }}{{ 'common.euro' | translate }}</span
            >
          </div>
          <div *ngIf="pvpMechanicalOrders">
            <div class="sidebar__price-item sidebar__price-start-section">
              <span class="sidebar__price-item-name">
                <b>Car Service</b>
              </span>
            </div>
            <ng-container
              *ngFor="
                let mechanical_order of offerData?.offer?.mechanical_orders
              "
            >
              <div
                id="bkgSummaryPriceCarService-{{ i }}"
                *ngFor="
                  let car_service_estimate of mechanical_order
                    ?.mechanical_estimate?.car_service_estimates;
                  let i = index
                "
                class="sidebar__price-item"
              >
                <div>
                  <span [class.sidebar__price-item-text]="!readOnly">{{
                    car_service_estimate.name
                  }}</span>
                  <img
                    *ngIf="!readOnly"
                    (click)="onClickDetailCarService(car_service_estimate)"
                    src="assets/images/icons/info.svg"
                    [class]="
                      testABMode
                        ? 'sidebar__price-item-image-B'
                        : 'sidebar__price-item-image'
                    "
                  />
                  <img
                    *ngIf="!readOnly"
                    (click)="onClickRemoveCarService(car_service_estimate)"
                    src="assets/images/icons/close.svg"
                    [class]="
                      testABMode
                        ? 'sidebar__price-item-image-B'
                        : 'sidebar__price-item-image'
                    "
                  />
                </div>
                <span class="sidebar__price-item-price"
                  >{{
                    priceWithVAT(
                      car_service_estimate.mechanical_estimate_data
                        .base_standard_total
                    ) | number: '1.2-2'
                  }}{{ 'common.euro' | translate }}
                  <span
                    *ngIf="
                      car_service_estimate &&
                      checkFeesNotIncluded(car_service_estimate)
                    "
                  >
                    {{ 'servicesStep.bkgCarServices.needFees' | translate }}(*)
                  </span>
                </span>
              </div>
            </ng-container>
            <div *ngIf="pvpMechanicalOrderFerry" class="sidebar__price-item">
              <div>
                <span
                  (click)="onClickDetailExtra(selectedWash)"
                  [class.sidebar__price-item-text]="!readOnly"
                  >{{
                    'sharedModule.bkgSummaryPrice.removal' | translate
                  }}</span
                >
                <img
                  *ngIf="!readOnly"
                  (click)="onClickFerryCarService()"
                  src="assets/images/icons/info.svg"
                  [class]="
                    testABMode
                      ? 'sidebar__price-item-image-B'
                      : 'sidebar__price-item-image'
                  "
                />
              </div>
              <span class="sidebar__price-item-price"
                >{{
                  offerData?.offer?.pvp_mechanical_order_ferry
                    | number: '1.2-2'
                }}{{ 'common.euro' | translate }}</span
              >
            </div>
          </div>

          <div *ngIf="hasCustomTiresService" class="sidebar__price-item">
            <span>
              {{
                'sharedModule.bkgSummaryPrice.customTiresService' | translate
              }}
            </span>

            <span *ngIf="!pvpProductOption" class="sidebar__price-item-price"
              >-</span
            >
          </div>
          <div *ngIf="hasCustomServices" class="sidebar__price-item">
            <div>
              <span
                id="bkgSummaryPriceCustomService"
                [class.sidebar__price-item-text]="!readOnly"
                >{{
                  'sharedModule.bkgSummaryPrice.customService' | translate
                }}</span
              >
              <img
                *ngIf="!readOnly"
                (click)="onClickDetailCustomService()"
                src="assets/images/icons/info.svg"
                [class]="
                  testABMode
                    ? 'sidebar__price-item-image-B'
                    : 'sidebar__price-item-image'
                "
              />
              <img
                *ngIf="!readOnly"
                (click)="onClickRemoveCustomService()"
                src="assets/images/icons/close.svg"
                [class]="
                  testABMode
                    ? 'sidebar__price-item-image-B'
                    : 'sidebar__price-item-image'
                "
              />
            </div>
            <span *ngIf="!pvpProductOption" class="sidebar__price-item-price"
              >-</span
            >
          </div>
          <div
            *ngIf="pvpPromo || pvpPoints"
            class="sidebar__price-item sidebar__price-start-section"
          >
            <div>
              <span
                class="sidebar__price-item-name sidebar__price-item-discount"
                ><b>{{
                  'sharedModule.bkgSummaryPrice.totalWithoutPromo' | translate
                }}</b></span
              >
            </div>
            <span class="sidebar__price-item-price"
              ><b
                >{{
                  +offerData?.offer?.price +
                    +offerData?.offer?.pvp_promotion +
                    +offerData?.offer?.pvp_product_points | number: '1.2-2'
                }}{{ 'common.euro' | translate }}</b
              ></span
            >
          </div>
          <div *ngIf="pvpPromo" class="sidebar__price-item">
            <div>
              <span
                class="sidebar__price-item-name sidebar__price-item-discount"
                ><b
                  >{{ 'sharedModule.bkgSummaryPrice.promo' | translate }}
                  {{ offerData?.offer?.promos[0].name }}</b
                ></span
              >
              <img
                *ngIf="!readOnly"
                (click)="onClickRemovePromo()"
                src="assets/images/icons/close.svg"
                [class]="
                  testABMode
                    ? 'sidebar__price-item-image-B'
                    : 'sidebar__price-item-image'
                "
              />
            </div>
            <span class="sidebar__price-item-price"
              ><b
                >{{ -offerData?.offer?.pvp_promotion | number: '1.2-2'
                }}{{ 'common.euro' | translate }}</b
              ></span
            >
          </div>
          <div *ngIf="pvpPoints" class="sidebar__price-item">
            <div>
              <span
                class="sidebar__price-item-name sidebar__price-item-discount"
                >{{ 'sharedModule.bkgSummaryPrice.points' | translate }}"</span
              >
              <img
                *ngIf="!readOnly"
                (click)="onClickRemovePoints()"
                src="assets/images/icons/close.svg"
                [class]="
                  testABMode
                    ? 'sidebar__price-item-image-B'
                    : 'sidebar__price-item-image'
                "
              />
            </div>
            <span class="sidebar__price-item-price"
              >{{ -offerData?.offer?.pvp_product_points | number: '1.2-2'
              }}{{ 'common.euro' | translate }}</span
            >
          </div>
          <div class="sidebar__price-item sidebar__price-item--total">
            <span class="sidebar__price-item-name">{{
              'sharedModule.bkgSummaryPrice.total' | translate
            }}</span>
            <span class="sidebar__price-item-price"
              >{{ offerData?.offer?.price | number: '1.2-2'
              }}{{ 'common.euro' | translate }}</span
            >
          </div>
          <div *ngIf="pvpMechanicalOrders && showTaxes">
            <span class="sidebar__price-item-name sidebar__price-item--taxes">
              {{ taxesSentence }}
            </span>
          </div>
        </div>
        <div *ngIf="!readOnly" class="sidebar__content-item">
          <div class="sidebar__price-extra">
            <span class="sidebar__price-extra-item">{{
              'sharedModule.bkgSummaryPrice.payInParking' | translate
            }}</span>
            <span class="sidebar__price-extra-item">{{
              'sharedModule.bkgSummaryPrice.freeCancellation' | translate
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
